<template>
  <div>
    <q-dialog
      v-if="showPigProgressDialog"
      v-model="showRunInfo"
      seamless
      position="top"
    >
      <q-card :style="positionStyle">
        <q-card-section horizontal class="row items-center no-wrap q-pa-sm">
          <div v-if="showPigProgressDialog">
            <div class="q-pa-xs">
              <div class="row">
                <div class="col text-bold">
                  {{ toolName }} on {{ pigRun.name }}
                </div>
              </div>
              <div class="row">
                <div class="col text-caption">
                  Launch Time (UTC): {{ launchDateFormatted }}
                </div>
              </div>
              <div class="row">
                <div class="col text-caption">
                  Expected Speed:
                  {{
                    calculatedSpeedFormatted
                      ? calculatedSpeedFormatted + ' mph'
                      : '0 mph'
                  }}
                </div>
              </div>
              <div class="row">
                <div class="col text-caption">
                  Time To Next Track Marker: {{ etaNextFormated }}
                </div>
              </div>
              <div class="row">
                <div class="col text-caption">
                  Time To Run Complete: {{ etaCompleteFormated }}
                </div>
              </div>
            </div>
          </div>

          <q-space v-if="showPigProgressDialog" />
          <q-btn flat round icon="more_vert" :disable="!isOnline">
            <q-menu>
              <q-list style="min-width: 150px">
                <q-item v-close-popup clickable @click="onZoomToPig">
                  <q-item-section>Zoom to Pig</q-item-section>
                </q-item>

                <q-item
                  v-if="getuser() == 'admin' || getuser() == 'superadmin'"
                  v-close-popup
                  clickable
                  @click="onNotifications"
                >
                  <q-item-section>Notifications</q-item-section>
                </q-item>
                <q-item
                  v-if="getuser() == 'admin' || getuser() == 'superadmin'"
                  v-close-popup
                  clickable
                  @click="onAgmSelectList"
                >
                  <q-item-section>AGMs</q-item-section>
                </q-item>

                <q-item
                  v-if="getuser() == 'admin' || getuser() == 'superadmin'"
                  v-close-popup
                  clickable
                  @click="onEditLaunchTime"
                >
                  <q-item-section>Edit Launch Time</q-item-section>
                </q-item>

                <q-item v-close-popup clickable @click="onAddAGMMarker">
                  <q-item-section>Add Marker</q-item-section>
                </q-item>

                <q-item
                  v-if="getuser() == 'admin' || getuser() == 'superadmin'"
                  v-close-popup
                  clickable
                  @click="onCancelRun"
                >
                  <q-item-section>Cancel Run</q-item-section>
                </q-item>

                <q-item
                  v-if="getuser() == 'admin' || getuser() == 'superadmin'"
                  v-close-popup
                  clickable
                  @click="onPigRunEndPressed"
                >
                  <q-item-section>End/Save Run</q-item-section>
                </q-item>
              </q-list>
            </q-menu>
          </q-btn>
        </q-card-section>
      </q-card>
    </q-dialog>

    <q-dialog v-model="addPassageDialog">
      <q-card>
        <q-toolbar>
          <div class="text-blue-brand text-bold">Add Passage</div>
          <q-space />
          <q-btn flat round dense icon="close" @click="closeManualPsg" />
        </q-toolbar>
        <q-card-section>
          <q-form>
            <div v-if="showErrorMsg" class="col q-pb-sm">
              <q-badge class="q-ml-sm" color="red">
                {{ ManualPsg_ErrorMsg }}
              </q-badge>
            </div>

            <div class="column">
              <div class="col q-pb-sm">
                <q-select
                  v-model="passageMarker"
                  dense
                  color="blue-brand"
                  outlined
                  :options="pigRunMarkerNames"
                  label="AGM Marker"
                />
              </div>
              <div class="col q-pb-sm">
                <q-input
                  v-model="passageTimestamp"
                  dense
                  filled
                  label="Passage Time (UTC)"
                >
                  <template #prepend>
                    <q-icon name="event" class="cursor-pointer">
                      <q-popup-proxy
                        ref="qDateProxy"
                        transition-show="scale"
                        transition-hide="scale"
                      >
                        <q-date
                          v-model="passageTimestamp"
                          mask="YYYY-MM-DD HH:mm:ss"
                          @input="hideDateProxy"
                        />
                      </q-popup-proxy>
                    </q-icon>
                  </template>
                  <template #append>
                    <q-icon name="access_time" class="cursor-pointer">
                      <q-popup-proxy
                        ref="qTimeProxy"
                        transition-show="scale"
                        transition-hide="scale"
                      >
                        <q-time
                          v-model="passageTimestamp"
                          mask="YYYY-MM-DD HH:mm:ss"
                          format24h
                          @input="hideTimeProxy"
                        />
                      </q-popup-proxy>
                    </q-icon>
                  </template>
                </q-input>
              </div>
            </div>
            <q-separator />
            <q-card-actions align="center">
              <q-btn
                class="btn-brand"
                label="Cancel"
                no-caps
                @click="closeManualPsg"
              />
              <q-btn
                class="btn-brand"
                label="Add"
                type="button"
                :disabled="!passageMarker"
                no-caps
                @click="onAddPassageInfo"
              />
            </q-card-actions>
          </q-form>
        </q-card-section>
      </q-card>
    </q-dialog>

    <q-dialog v-model="showMissedPassages">
      <q-card style="width: 630px; max-width: 90vw">
        <q-toolbar>
          <q-toolbar-title class="text-blue-brand text-bold"
            >Unassociated Passages</q-toolbar-title
          >
          <q-btn v-close-popup flat round dense icon="close" />
        </q-toolbar>
        <q-table
          v-if="missedPassages && missedPassages.length"
          v-model:pagination="passagePagination"
          table-header-class="bg-blue-brand text-white"
          :rows="missedPassages"
          :columns="missedPassageColumns"
          row-key="name"
          dense
        >
          <template #body-cell-graph-data="props">
            <q-td :props="props">
              <q-btn
                v-if="props.row.elfId"
                size="sm"
                class="q-mr-xs btn-brand"
                dense
                icon="show_chart"
                label="ELF"
                @click="onShowChart(props, 'ELF')"
              >
              </q-btn>
              <q-btn
                v-if="props.row.geoId"
                size="sm"
                class="q-mr-xs btn-brand"
                dense
                icon="show_chart"
                label="GEO"
                @click="onShowChart(props, 'GEO')"
              >
              </q-btn>
              <q-btn
                v-if="props.row.magId"
                size="sm"
                class="q-mr-xs btn-brand"
                dense
                icon="show_chart"
                label="MAG"
                @click="onShowChart(props, 'MAG')"
              >
              </q-btn>
            </q-td>
          </template>
          <template #body-cell-add-data="props">
            <q-td :props="props">
              <q-btn
                v-if="
                  props.row.passageId &&
                  (getuser() == 'admin' || getuser() == 'superadmin')
                "
                size="sm"
                class="q-mr-xs btn-brand"
                icon="fas fa-plus"
                label="Add to Marker"
                dense
                @click="onAddMissedPassage(props.row)"
              >
              </q-btn>
            </q-td>
          </template>
        </q-table>
      </q-card>
    </q-dialog>

    <q-dialog v-model="cancelConfirmDialog">
      <q-card style="width: 250px; max-width: 90vw">
        <q-toolbar>
          <q-toolbar-title class="text-blue-brand text-bold"
            >Cancel Pig Run</q-toolbar-title
          >
          <q-btn v-close-popup flat round dense icon="close" />
        </q-toolbar>
        <q-card-section>
          <div class="column">
            <div class="col q-pb-sm">Are you sure you want to cancel?</div>
          </div>
          <q-separator />
          <q-card-actions align="center">
            <q-btn v-close-popup class="btn-brand" label="No" no-caps />
            <q-btn
              v-close-popup
              class="btn-brand"
              label="Yes-Cancel"
              no-caps
              @click="onCancelConfirm"
            />
          </q-card-actions>
        </q-card-section>
      </q-card>
    </q-dialog>

    <q-dialog v-model="deleteConfirmDialog">
      <q-card style="width: 350px; max-width: 90vw">
        <q-toolbar>
          <q-toolbar-title class="text-blue-brand text-bold"
            >Delete Passage</q-toolbar-title
          >
          <q-btn v-close-popup flat round dense icon="close" />
        </q-toolbar>
        <q-card-section>
          <div class="column">
            <div class="col q-pb-sm">
              Are you sure you want to delete this passage?
            </div>
          </div>
          <q-separator />
          <q-card-actions align="center">
            <q-btn v-close-popup class="btn-brand" label="No" no-caps />
            <q-btn
              v-close-popup
              class="btn-brand"
              label="Yes"
              no-caps
              @click="onDeleteManualPassage"
            />
          </q-card-actions>
        </q-card-section>
      </q-card>
    </q-dialog>

    <q-dialog v-model="editConfirmDialog">
      <q-card>
        <q-toolbar>
          <q-toolbar-title class="text-blue-brand text-bold"
            >Edit Manual Passage</q-toolbar-title
          >
          <q-space />
          <q-btn
            v-close-popup
            flat
            round
            dense
            icon="close"
            @click="closeManualPsg"
          />
        </q-toolbar>
        <q-card-section>
          <q-form v-if="EditManual_ErrorMsg">
            <q-badge class="q-ml-sm" color="red">
              {{ ManualPsg_ErrorMsg }}
            </q-badge>
          </q-form>

          <q-form>
            <div class="column">
              <div class="col q-pb-sm">
                <q-input
                  v-model="EditManualPsgTimestamp"
                  dense
                  filled
                  label="Passage Time (UTC)"
                >
                  <template #prepend>
                    <q-icon name="event" class="cursor-pointer">
                      <q-popup-proxy
                        ref="qDateProxy"
                        transition-show="scale"
                        transition-hide="scale"
                      >
                        <q-date
                          v-model="EditManualPsgTimestamp"
                          mask="YYYY-MM-DD HH:mm:ss"
                          @input="hideDateProxy"
                        />
                      </q-popup-proxy>
                    </q-icon>
                  </template>
                  <template #append>
                    <q-icon name="access_time" class="cursor-pointer">
                      <q-popup-proxy
                        ref="qTimeProxy"
                        transition-show="scale"
                        transition-hide="scale"
                      >
                        <q-time
                          v-model="EditManualPsgTimestamp"
                          mask="YYYY-MM-DD HH:mm:ss"
                          format24h
                          @input="hideTimeProxy"
                        />
                      </q-popup-proxy>
                    </q-icon>
                  </template>
                </q-input>
              </div>
            </div>
            <q-separator />
            <q-card-actions align="center">
              <q-btn
                v-close-popup
                class="btn-brand"
                label="Cancel"
                no-caps
                @click="closeManualPsg"
              />
              <q-btn
                class="btn-brand"
                label="Set"
                type="button"
                no-caps
                @click="onEditManualPsg"
              />
            </q-card-actions>
          </q-form>
        </q-card-section>
      </q-card>
    </q-dialog>

    <q-dialog v-model="addNoteDialog">
      <q-card style="width: 250px; max-width: 90vw">
        <q-toolbar>
          <q-toolbar-title class="text-blue-brand text-bold"
            >Add Note</q-toolbar-title
          >
          <q-btn v-close-popup flat round dense icon="close" />
        </q-toolbar>
        <form>
          <q-card-section>
            <div class="column">
              <q-input
                v-model="noteText"
                filled
                type="textarea"
                autogrow
                autofocus
                dense
                :rules="[
                  (val) =>
                    val.length <= 200 || 'Notes are limited to 200 characters',
                ]"
              />
            </div>
            <q-separator />
            <q-card-actions align="center">
              <q-btn
                v-close-popup
                :disable="noteText.length > 200"
                class="btn-brand"
                label="Save"
                no-caps
                @click="onSaveNote"
              />
            </q-card-actions>
          </q-card-section>
        </form>
      </q-card>
    </q-dialog>

    <q-dialog v-model="assignUidDialog">
      <q-card style="width: 300px; max-width: 90vw">
        <q-toolbar>
          <q-toolbar-title class="text-blue-brand text-bold"
            >Assign UID</q-toolbar-title
          >
          <q-btn v-close-popup flat round dense icon="close" />
        </q-toolbar>
        <q-card-section>
          <q-form>
            <div v-if="availableUids.length" class="column">
              <div class="col q-pb-sm">
                Link marker <b>{{ selectedMarkerName }}</b> to AGM Device UID
              </div>
              <div class="col q-pb-sm">
                <q-select
                  v-model="selectedUid"
                  dense
                  color="blue-brand"
                  autofocus
                  outlined
                  :options="availableUids"
                  label="AGM Device UID"
                />
              </div>
            </div>
            <div v-else class="column">
              No AGMs have been assigned to this pig run
            </div>
            <q-separator />
            <q-card-actions align="center">
              <q-btn v-close-popup class="btn-brand" label="Cancel" no-caps />
              <q-btn
                v-close-popup
                class="btn-brand"
                label="Link"
                type="button"
                :disabled="!selectedUid"
                no-caps
                @click="onSaveUidLink"
              />
            </q-card-actions>
          </q-form>
        </q-card-section>
      </q-card>
    </q-dialog>

    <q-dialog v-model="changeNotificationsDialog">
      <q-card style="width: 300px; max-width: 90vw">
        <q-toolbar>
          <q-toolbar-title class="text-blue-brand text-bold"
            >Notifications</q-toolbar-title
          >
          <q-btn v-close-popup flat round dense icon="close" />
        </q-toolbar>
        <q-card-section>
          <SmsNotifications
            :markers="pigRun ? pigRun.markers : []"
            :notifications="userNotifications"
            @update-notifications="onUpdateNotifications"
          />
          <q-separator />
          <q-card-actions align="center">
            <q-btn v-close-popup class="btn-brand" label="Cancel" no-caps />
            <q-btn
              v-close-popup
              class="btn-brand"
              label="Save"
              type="button"
              no-caps
              @click="onSaveUserNotifications"
            />
          </q-card-actions>
        </q-card-section>
      </q-card>
    </q-dialog>

    <q-dialog v-model="changeSpeedDialog">
      <q-card style="width: 300px; max-width: 90vw">
        <q-toolbar>
          <q-toolbar-title class="text-blue-brand text-bold"
            >Edit Tool Speed</q-toolbar-title
          >
          <q-btn v-close-popup flat round dense icon="close" />
        </q-toolbar>
        <q-card-section>
          <q-separator />
          <div class="q-gutter-md row items-start">
            <div class="q-gutter-md row items-start">
              <q-space></q-space>
              <q-input
                v-model="newSpeed"
                dense
                outlined
                color="blue-brand"
                step="0.5"
                min="0"
                max-decimals="2"
                type="number"
                :label="SpeedDesc"
                style="max-width: 200px; width: 100px; height: 30px"
              ></q-input>
              <q-btn-dropdown
                no-caps
                size="12px"
                color="grey-9"
                :label="SpeedUnits"
                style="width: 70px; height: 30px"
              >
                <q-list>
                  <q-item
                    v-close-popup
                    clickable
                    @click="onSpeedUnitsSelect(1)"
                  >
                    <q-item-section>
                      <q-item-label>m/s</q-item-label>
                    </q-item-section>
                  </q-item>

                  <q-item
                    v-close-popup
                    clickable
                    @click="onSpeedUnitsSelect(2)"
                  >
                    <q-item-section>
                      <q-item-label>mph</q-item-label>
                    </q-item-section>
                  </q-item>
                </q-list>
              </q-btn-dropdown>
            </div>
          </div>
          <q-card-actions align="center">
            <q-btn v-close-popup class="btn-brand" label="Cancel" no-caps />
            <q-btn
              v-close-popup
              class="btn-brand"
              label="Save"
              type="button"
              no-caps
              @click="onSaveNewSpeed"
            />
          </q-card-actions>
        </q-card-section>
      </q-card>
    </q-dialog>

    <q-dialog v-model="addAgmsDialog">
      <q-card style="min-width: 620px">
        <q-toolbar>
          <q-toolbar-title class="text-blue-brand text-bold"
            >Edit Available AGMs</q-toolbar-title
          >
          <q-btn v-close-popup flat round dense icon="close" />
        </q-toolbar>
        <q-card-section>
          <AgmPicker
            :available-agms="agmAvailableList"
            :selected-agms="agmSelectedList"
            @update:available-agms="agmAvailableList = $event"
            @update:selected-agms="agmSelectedList = $event"
          />
          <q-separator class="q-mt-md" />
          <q-card-actions align="center">
            <q-btn v-close-popup class="btn-brand" label="Cancel" no-caps />
            <q-btn
              class="btn-brand"
              label="Save"
              no-caps
              @click="onAgmListChanged"
            />
          </q-card-actions>
        </q-card-section>
      </q-card>
    </q-dialog>

    <q-dialog v-model="endPigRunDialog">
      <q-card>
        <q-toolbar>
          <div class="text-blue-brand text-bold">Add Receive Time</div>
          <q-space />
          <q-btn v-close-popup flat round dense icon="close" />
        </q-toolbar>
        <q-card-section>
          <q-form>
            <div class="column">
              <div class="col q-pb-sm">
                <q-input
                  v-model="ReceiveTimestamp"
                  dense
                  filled
                  label="Receive Time (UTC)"
                  :rules="[(val) => ValidateReceiveTime(val)]"
                >
                  <template #prepend>
                    <q-icon name="event" class="cursor-pointer">
                      <q-popup-proxy
                        ref="qDateProxy"
                        transition-show="scale"
                        transition-hide="scale"
                      >
                        <q-date
                          v-model="ReceiveTimestamp"
                          mask="YYYY-MM-DD HH:mm:ss"
                          @input="hideDateProxy"
                        />
                      </q-popup-proxy>
                    </q-icon>
                  </template>
                  <template #append>
                    <q-icon name="access_time" class="cursor-pointer">
                      <q-popup-proxy
                        ref="qTimeProxy"
                        transition-show="scale"
                        transition-hide="scale"
                      >
                        <q-time
                          v-model="ReceiveTimestamp"
                          mask="YYYY-MM-DD HH:mm:ss"
                          format24h
                          @input="hideTimeProxy"
                        />
                      </q-popup-proxy>
                    </q-icon>
                  </template>
                </q-input>
              </div>
            </div>
            <q-separator />
            <q-card-actions align="center">
              <q-btn v-close-popup class="btn-brand" label="Cancel" no-caps />
              <q-btn
                class="btn-brand"
                label="Add"
                type="button"
                no-caps
                @click="onEndRunConfirmPressed"
              />
            </q-card-actions>
          </q-form>
        </q-card-section>
      </q-card>
    </q-dialog>

    <q-dialog v-model="endPigRunConfirmDialog">
      <q-card style="width: 350px; max-width: 90vw">
        <q-toolbar>
          <q-toolbar-title class="text-blue-brand text-bold"
            >Confirm End Run</q-toolbar-title
          >
          <q-btn v-close-popup flat round dense icon="close" />
        </q-toolbar>
        <q-card-section>
          <div class="column">
            <div class="col q-pb-xs"><b>Run:</b> {{ pigRun.name }}</div>
            <div class="col q-pb-xs">
              <b>Launch (UTC):</b> {{ launchDateFormatted }}
            </div>
            <div class="col q-pb-xs">
              <b>Receive (UTC):</b> {{ ReceiveTimestamp }}
            </div>
          </div>
          <q-separator class="q-mt-sm" />
          <q-card-actions align="center">
            <q-btn v-close-popup class="btn-brand" label="Cancel" no-caps />
            <q-btn
              class="btn-brand"
              label="End/Save"
              no-caps
              @click="onEndRun"
            />
          </q-card-actions>
        </q-card-section>
      </q-card>
    </q-dialog>

    <q-dialog v-model="Launch_at_TimeDialog">
      <q-card style="min-width: 450px">
        <q-toolbar>
          <q-toolbar-title class="text-blue-brand text-bold"
            >Edit Launch Time</q-toolbar-title
          >

          <q-space />
          <q-btn v-close-popup flat round dense icon="close" />
        </q-toolbar>
        <q-card-section>
          <q-form v-if="ErrorMsg">
            <q-badge class="q-ml-sm" color="red"
              >Error ! Launch cannot be set to future time.</q-badge
            >
          </q-form>

          <q-form>
            <div class="column">
              <div class="col q-pb-sm">
                <q-input
                  v-model="LaunchTimestamp"
                  dense
                  filled
                  label="Launch Time (UTC)"
                >
                  <template #prepend>
                    <q-icon name="event" class="cursor-pointer">
                      <q-popup-proxy
                        ref="qDateProxy"
                        transition-show="scale"
                        transition-hide="scale"
                      >
                        <q-date
                          v-model="LaunchTimestamp"
                          mask="YYYY-MM-DD HH:mm:ss"
                          @input="hideDateProxy"
                        />
                      </q-popup-proxy>
                    </q-icon>
                  </template>
                  <template #append>
                    <q-icon name="access_time" class="cursor-pointer">
                      <q-popup-proxy
                        ref="qTimeProxy"
                        transition-show="scale"
                        transition-hide="scale"
                      >
                        <q-time
                          v-model="LaunchTimestamp"
                          mask="YYYY-MM-DD HH:mm:ss"
                          format24h
                          @input="hideTimeProxy"
                        />
                      </q-popup-proxy>
                    </q-icon>
                  </template>
                </q-input>
              </div>
            </div>
            <q-separator />
            <q-card-actions align="center">
              <q-btn v-close-popup class="btn-brand" label="Cancel" no-caps />
              <q-btn
                class="btn-brand"
                label="Save"
                type="button"
                no-caps
                @click="onSaveLaunchTime"
              />
            </q-card-actions>
          </q-form>
        </q-card-section>
      </q-card>
    </q-dialog>

    <q-dialog v-model="EditPigDialog">
      <q-card style="width: 450px">
        <q-toolbar>
          <!-- <div class="text-blue-brand text-bold">Edit Pig Location/Speed</div> -->
          <q-toolbar-title class="text-blue-brand text-bold"
            >Edit Pig Info</q-toolbar-title
          >

          <q-space />
          <q-btn v-close-popup flat round dense icon="close" />
        </q-toolbar>
        <q-card-section>
          <q-input
            ref="Speed_Validation"
            v-model="tempMarker_Speed"
            dense
            color="blue-brand"
            type="number"
            outlined
            label="Expected Speed (mph)"
            :rules="[
              (val) =>
                (val && val.length > 0) ||
                'Expected speed required to update Pig Location',
            ]"
          />

          <div class="q-gutter-md row items-start">
            <q-input
              v-model="tempMarker_lat"
              dense
              color="blue-brand"
              type="number"
              outlined
              label="Pig New Lat"
              :disable="true"
              :rules="[
                (val) =>
                  (val && val.length > 0) || 'Valid Lat value is required',
              ]"
            />
            <q-input
              v-model="tempMarker_lon"
              dense
              color="blue-brand"
              type="number"
              outlined
              label="Pig New Lon"
              :disable="true"
              :rules="[
                (val) =>
                  (val && val.length > 0) || 'Valid Lon value is required',
              ]"
            />
          </div>
        </q-card-section>
        <q-card-actions align="center">
          <q-btn
            v-close-popup
            no-caps
            class="btn-brand"
            label="Cancel"
            @click="onCancelEditSpeed"
          />
          <q-btn
            v-close-popup
            no-caps
            class="btn-brand"
            label="Save"
            @click="onEditRunSpeed"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog v-model="addMarkerDialog" seamless position="bottom">
      <q-card>
        <q-toolbar>
          <q-toolbar-title class="text-blue-brand text-bold"
            >Marker Configuration</q-toolbar-title
          >
          <q-btn
            v-close-popup
            flat
            round
            dense
            icon="close"
            @click="onCloseNewMarkerSetup"
          />
        </q-toolbar>
        <q-card-section>
          <div v-if="newMarkerError" class="q-pb-sm">
            <q-badge color="red">{{ newMarkerError }}</q-badge>
          </div>
          <q-input
            v-model="newMarkerName"
            filled
            type="textarea"
            autogrow
            autofocus
            dense
            label="Marker Name"
            :rules="[
              (val) =>
                val.length <= 20 || 'Marker Name is limited to 20 characters',
            ]"
          />

          <div class="q-gutter-md row items-start">
            <q-input
              v-model="newMarker_lat"
              dense
              color="blue-brand"
              type="number"
              outlined
              label="Pig New Lat"
              :disable="true"
              :rules="[
                (val) =>
                  (val && val.length > 0) || 'Valid Lat value is required',
              ]"
            />
            <q-input
              v-model="newMarker_lon"
              dense
              color="blue-brand"
              type="number"
              outlined
              label="Pig New Lon"
              :disable="true"
              :rules="[
                (val) =>
                  (val && val.length > 0) || 'Valid Lon value is required',
              ]"
            />
          </div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          <div class="text-subtitle2 q-mb-xs">Link Device</div>
          <q-select
            v-model="selectedDeviceUid"
            :options="availableDevicesForMarker"
            label="Select a device"
            emit-value
            map-options
            dense
            outlined
            color="blue-brand"
            :loading="loadingAvailableDevices"
            :rules="[(val) => val != null || 'A device is required.']"
          />
        </q-card-section>

        <q-card-actions align="center">
          <q-btn
            no-caps
            class="btn-brand"
            label="Save"
            @click="onSaveNewMarker"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <!-- Waveform selection dialog for verification -->
    <q-dialog v-model="showWaveformSelectionDialog">
      <q-card style="min-width: 300px">
        <q-card-section>
          <div class="text-h6">Select Waveform to Verify</div>
          <div class="text-body2 q-mt-sm">
            Choose which waveform type to verify for this passage.
          </div>
        </q-card-section>
        <q-card-section>
          <q-option-group
            v-model="selectedWaveformId"
            :options="waveformOptionsForVerify"
            type="radio"
          />
        </q-card-section>
        <q-card-actions align="right">
          <q-btn
            flat
            label="Cancel"
            class="btn-brand"
            @click="onCancelWaveformSelection"
          />
          <q-btn
            flat
            label="Confirm"
            class="btn-brand"
            color="primary"
            :disable="selectedWaveformId === null"
            @click="onConfirmWaveformSelection"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <!-- Add Marker instruction card -->
    <InstructionCard
      v-model="showAddMarkerInstructions"
      title="Add Marker"
      icon="ads_click"
      message="Select a point on the map where you want to add a marker to this pig run."
      tip="Tip: Select a point on the pipeline to ensure the marker accurately reflects your pig run."
      @update:model-value="
        (val) => {
          if (!val) onCancelAddMarker();
        }
      "
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, markRaw, PropType } from 'vue';
import L from 'leaflet';
import { hidePopupProxy } from '@/utils/QuasarProxyHelper';
import { ActivePigRun, PipelineSectionMarker } from '@/models/ActivePigRun';
import { PigRunMapEntry } from '@/models/PigRunState';
import { PigRunNotification } from '@/models/PigRunNotification';
import { UserNotification } from '@/models/UserNotification';
import PigRunCommon from '@/utils/PigRunCommon';
import PigRunService from '@/services/PigRunService';
import DeviceService from '@/services/DeviceService';
import SmsNotifications from '@/components/SmsNotifications.vue';
import AgmPicker from '@/components/AgmPicker.vue';
import InstructionCard from '@/components/InstructionCard.vue';

export default defineComponent({
  name: 'PigProgressCard',
  components: { SmsNotifications, AgmPicker, InstructionCard },
  props: {
    pigRun: { type: Object as PropType<ActivePigRun>, default: () => ({}) },
    position: { type: Number, default: 0 },
  },
  data() {
    return {
      showRunInfo: true,
      showPigProgressDialog: true,
      addPassageDialog: false,
      passageMarker: '',
      passageTimestamp: '',
      showMissedPassages: false,
      cancelConfirmDialog: false,
      deleteConfirmDialog: false,
      editConfirmDialog: false,
      EditManualPsgTimestamp: '',
      addNoteDialog: false,
      noteText: '',
      assignUidDialog: false,
      selectedUid: '',
      changeNotificationsDialog: false,
      changeSpeedDialog: false,
      newSpeed: 0,
      addAgmsDialog: false,
      tmpSelectedAgms: [],
      agmAvailableList: [] as { label: string; value: number }[],
      agmSelectedList: [] as { label: string; value: number }[],
      endPigRunDialog: false,
      endPigRunConfirmDialog: false,
      ReceiveTimestamp: '',
      Launch_at_TimeDialog: false,
      LaunchTimestamp: '',
      EditPigDialog: false,
      tempMarker_Speed: '',
      tempMarker_lat: '',
      tempMarker_lon: '',
      addMarkerDialog: false,
      newMarkerName: '',
      newMarker_lat: '',
      newMarker_lon: '',
      showAddMarkerInstructions: false,
      tempAGMMarker: null as L.Marker | null,
      newMarkerError: '',
      selectedDeviceUid: null as number | null,
      availableDevicesForMarker: [] as { label: string; value: number }[],
      loadingAvailableDevices: false,
      showWaveformSelectionDialog: false,
      selectedWaveformId: null,
      showErrorMsg: false,
      ManualPsg_ErrorMsg: '',
      selectedMarkerName: '',
      passagePagination: { rowsPerPage: 10 },
      missedPassageColumns: [],
      EditManual_ErrorMsg: false,
      userNotifications: [] as UserNotification[],
      tmpUserNotifications: [] as UserNotification[],

      ErrorMsg: false,
      ErrorMsgString: '',
      waveformOptionsForVerify: [],
      agmUidOptions: [],
    };
  },
  computed: {
    toolName(): string {
      if (this.pigRun.tools && this.pigRun.tools.length > 0) {
        return this.pigRun.tools[0].name;
      }
      return '';
    },
    sortedMarkers(): PipelineSectionMarker[] {
      if (!this.pigRun.markers) return [];
      return [...this.pigRun.markers].sort((a, b) => a.sortOrder - b.sortOrder);
    },
    trackMarkers(): PipelineSectionMarker[] {
      return this.sortedMarkers.filter((m) => m.trackState === 'T');
    },
    expectedSpeedFormatted(): string {
      if (!this.pigRun.expectedSpeed) return '0';
      return (
        Math.round(
          PigRunCommon.metersToMiles(this.pigRun.expectedSpeed) * 100
        ) / 100
      ).toString();
    },
    calculatedSpeedFormatted(): string {
      const entry = this.pigRunEntry;
      if (!entry?.pigLocation?.speed) return '';
      return (
        Math.round(PigRunCommon.metersToMiles(entry.pigLocation.speed) * 100) /
        100
      ).toString();
    },
    etaNextFormated(): string {
      const entry = this.pigRunEntry;
      if (!entry?.pigLocation) return '';
      return this.formatEta(entry.pigLocation.etaToNextTrack);
    },
    etaCompleteFormated(): string {
      const entry = this.pigRunEntry;
      if (!entry?.pigLocation) return '';
      return this.formatEta(entry.pigLocation.etaToEnd);
    },
    isOnline(): boolean {
      return navigator.onLine;
    },
    launchDateFormatted(): string {
      if (!this.pigRun.launchDate) return '';
      return this.pigRun.launchDate.split('.')[0];
    },
    pigRunMarkerNames(): string[] {
      return this.sortedMarkers.map((m) => m.name);
    },

    missedPassages(): any[] {
      return this.$store.state.pigRun.missedPassages || [];
    },
    availableUids(): string[] {
      return [];
    },
    SpeedDesc(): string {
      return '';
    },
    SpeedUnits(): string {
      return '';
    },
    positionStyle(): string {
      const offset = this.position * 180;
      return `margin-top: ${offset}px; min-width: 350px`;
    },
    pigRunEntry(): PigRunMapEntry | undefined {
      if (!this.pigRun?.pigRunId) return undefined;
      return (
        this.$store.state.pigRun.pigRuns as Record<number, PigRunMapEntry>
      )[this.pigRun.pigRunId];
    },
  },
  methods: {
    getuser(): string {
      return this.$store.state.user?.role || '';
    },
    getMLResultColor(_list: any): string {
      return '';
    },
    getMLIcon(_color: string): string {
      return '';
    },
    getMLResultConfidence(_list: any): string {
      return '';
    },
    ValidateReceiveTime(ts: string): true | string {
      if (!ts) return 'Receive Time is required.';
      const receiveDate = new Date(ts.replace(' ', 'T') + 'Z');
      if (isNaN(receiveDate.getTime())) return 'Invalid date format.';
      if (receiveDate.getTime() > Date.now()) {
        return 'Receive Time cannot be in the future.';
      }
      if (this.pigRun.launchDate) {
        const launchStr = this.pigRun.launchDate.replace(' ', 'T');
        const launchDate = new Date(
          launchStr.endsWith('Z') ? launchStr : launchStr + 'Z'
        );
        if (receiveDate.getTime() < launchDate.getTime()) {
          return 'Receive Time cannot be before Launch Time.';
        }
      }
      return true;
    },
    handleNextMarker(_dir: string) {},
    onZoomToPig() {
      const pigLoc = this.pigRunEntry?.pigLocation;
      if (pigLoc?.lat && pigLoc?.lon) {
        this.$store.dispatch('goToLatLon', {
          lat: pigLoc.lat,
          lon: pigLoc.lon,
        });
        return;
      }
      // Fallback: zoom to the first marker with coordinates
      const marker = this.sortedMarkers.find((m) => m.latitude && m.longitude);
      if (marker) {
        this.$store.dispatch('goToLatLon', {
          lat: marker.latitude,
          lon: marker.longitude,
        });
      }
    },
    async onNotifications() {
      try {
        const response = await PigRunService.getNotifications(
          this.pigRun.pigRunId
        );
        const notifications: PigRunNotification[] = response.data || [];
        this.userNotifications =
          this.pigRunNotificationsToUserNotifications(notifications);
        this.tmpUserNotifications = [...this.userNotifications];
      } catch (err) {
        console.error('Failed to load notifications:', err);
        this.userNotifications = [];
        this.tmpUserNotifications = [];
      }
      this.changeNotificationsDialog = true;
    },
    async onAgmSelectList() {
      // Build the selected list from current pig run devices
      const currentUids = (this.pigRun.devices || []).map(
        (d: { uid: number }) => d.uid
      );
      this.agmSelectedList = currentUids
        .map((uid: number) => ({ label: String(uid), value: uid }))
        .sort((a: any, b: any) => a.value - b.value);

      // Fetch all devices and build the available list (excluding already selected)
      try {
        const response = await DeviceService.getDevices();
        const allAgms = (response.data || [])
          .map((d: any) => ({ label: String(d.uId), value: d.uId as number }))
          .sort((a: any, b: any) => a.value - b.value);
        this.agmAvailableList = allAgms.filter(
          (a: { value: number }) => !currentUids.includes(a.value)
        );
      } catch (err) {
        console.error('Failed to fetch AGMs:', err);
        this.agmAvailableList = [];
      }

      this.addAgmsDialog = true;
    },
    onEditLaunchTime() {
      if (!this.pigRun) return;
      this.ErrorMsg = false;

      if (this.pigRun.launchDate) {
        // launchDate is a string like "2026-03-25T14:30:45" or "2026-03-25 14:30:45"
        this.LaunchTimestamp = this.pigRun.launchDate
          .replace('T', ' ')
          .split('.')[0];
      } else {
        const now = new Date();
        const pad = (n: number) => n.toString().padStart(2, '0');
        this.LaunchTimestamp =
          now.getUTCFullYear() +
          '-' +
          pad(now.getUTCMonth() + 1) +
          '-' +
          pad(now.getUTCDate()) +
          ' ' +
          pad(now.getUTCHours()) +
          ':' +
          pad(now.getUTCMinutes()) +
          ':' +
          pad(now.getUTCSeconds());
      }

      this.Launch_at_TimeDialog = true;
    },
    onAddAGMMarker() {
      const map: L.Map | undefined = this.$store.state.map;
      if (!map) return;

      // Show instruction card and change cursor to crosshair
      this.showAddMarkerInstructions = true;
      map.getContainer().style.cursor = 'crosshair';

      map.once('click', (e: L.LeafletMouseEvent) => {
        // Hide instructions and restore cursor
        this.showAddMarkerInstructions = false;
        map.getContainer().style.cursor = '';

        this.newMarker_lat = e.latlng.lat.toString();
        this.newMarker_lon = e.latlng.lng.toString();

        // Place a draggable temporary marker
        const tmpMarker = L.marker(L.latLng(e.latlng.lat, e.latlng.lng), {
          draggable: true,
          icon: PigRunCommon.trackIcon_3,
          zIndexOffset: -5,
        }).bindTooltip(e.latlng.lat + ',' + e.latlng.lng);
        this.tempAGMMarker = markRaw(tmpMarker);

        this.tempAGMMarker.on('dragend', () => {
          if (this.tempAGMMarker) {
            const pos = this.tempAGMMarker.getLatLng();
            this.newMarker_lat = pos.lat.toString();
            this.newMarker_lon = pos.lng.toString();
            this.tempAGMMarker.setTooltipContent(`${pos.lat},${pos.lng}`);
          }
        });

        this.tempAGMMarker.addTo(map);
        this.addMarkerDialog = true;
        this.selectedDeviceUid = null;
        this.loadAvailableDevicesForMarker();
      });
    },
    async loadAvailableDevicesForMarker() {
      this.loadingAvailableDevices = true;
      try {
        const runDeviceUids = new Set(
          (this.pigRun.devices || []).map((d: { uid: number }) => d.uid)
        );
        const response = await DeviceService.getDevices();
        this.availableDevicesForMarker = (response.data || [])
          .filter((d: any) => !runDeviceUids.has(d.uId as number))
          .map((d: any) => ({ label: String(d.uId), value: d.uId as number }))
          .sort(
            (a: { value: number }, b: { value: number }) => a.value - b.value
          );
      } catch (err) {
        console.error('Failed to load available devices:', err);
        this.availableDevicesForMarker = [];
      } finally {
        this.loadingAvailableDevices = false;
      }
    },
    onCancelAddMarker() {
      const map: L.Map | undefined = this.$store.state.map;
      if (map) {
        map.off('click');
        map.getContainer().style.cursor = '';
      }
      this.showAddMarkerInstructions = false;
    },
    onCancelRun() {
      this.cancelConfirmDialog = true;
    },
    async onCancelConfirm() {
      try {
        await PigRunService.cancelPigRun(this.pigRun.pigRunId);
        this.$store.commit('REMOVE_ACTIVE_PIG_RUN', this.pigRun.pigRunId);
      } catch (err) {
        console.error('cancelPigRun failed:', err);
      }
    },
    onPigRunEndPressed() {
      const now = new Date();
      const pad = (n: number) => n.toString().padStart(2, '0');
      this.ReceiveTimestamp =
        now.getUTCFullYear() +
        '-' +
        pad(now.getUTCMonth() + 1) +
        '-' +
        pad(now.getUTCDate()) +
        ' ' +
        pad(now.getUTCHours()) +
        ':' +
        pad(now.getUTCMinutes()) +
        ':' +
        pad(now.getUTCSeconds());
      this.endPigRunDialog = true;
    },
    closeManualPsg() {},
    formatEta(value: string | number | undefined): string {
      if (value == null) return '';
      // If the value is a number (or a numeric string), treat it as total seconds
      const num = typeof value === 'number' ? value : parseFloat(value);
      if (!isNaN(num)) {
        const totalSeconds = Math.round(Math.abs(num));
        const h = Math.floor(totalSeconds / 3600)
          .toString()
          .padStart(2, '0');
        const m = Math.floor((totalSeconds % 3600) / 60)
          .toString()
          .padStart(2, '0');
        const s = (totalSeconds % 60).toString().padStart(2, '0');
        return `${h}:${m}:${s}`;
      }
      // Fallback: handle .NET TimeSpan string formats "h:mm:ss", "d.hh:mm:ss"
      const str = String(value);
      const cleaned =
        str.split('.').length > 2
          ? str.substring(0, str.lastIndexOf('.'))
          : str;
      const parts = cleaned.split(':');
      if (parts.length === 3) {
        const hh = parts[0].padStart(2, '0');
        const mm = parts[1].padStart(2, '0');
        const ss = parts[2].split('.')[0].padStart(2, '0');
        return `${hh}:${mm}:${ss}`;
      }
      return str;
    },
    onAddPassageInfo() {},
    onShowChart(_props: any, _type: string) {},
    onAddMissedPassage(_row: any) {},
    onDeleteManualPassage() {},
    onEditManualPsg() {},
    onSaveNote() {},
    onSaveUidLink() {},
    onUpdateNotifications(val: UserNotification[]) {
      this.tmpUserNotifications = val;
    },
    async onSaveUserNotifications() {
      try {
        const notifications = this.userNotificationsToPigRunNotifications(
          this.tmpUserNotifications
        );
        await PigRunService.saveNotifications(
          this.pigRun.pigRunId,
          notifications
        );
        this.userNotifications = [...this.tmpUserNotifications];
      } catch (err) {
        console.error('Failed to save notifications:', err);
      }
    },
    onSpeedUnitsSelect(_n: number) {},
    onSaveNewSpeed() {},
    async onAgmListChanged() {
      const selectedUids = this.agmSelectedList.map((a) => a.value);
      try {
        const response = await PigRunService.updateDevices(
          this.pigRun.pigRunId,
          selectedUids
        );
        this.$store.commit('SET_PIG_RUN', response.data);
        this.addAgmsDialog = false;
      } catch (err) {
        console.error('updateDevices failed:', err);
      }
    },
    onEndRunConfirmPressed() {
      if (this.ValidateReceiveTime(this.ReceiveTimestamp) !== true) return;
      this.endPigRunConfirmDialog = true;
    },
    async onEndRun() {
      try {
        const receiveDate = this.ReceiveTimestamp.replace(' ', 'T');
        await PigRunService.endPigRun(this.pigRun.pigRunId, receiveDate);
        this.$store.commit('REMOVE_ACTIVE_PIG_RUN', this.pigRun.pigRunId);
        this.$store.dispatch('RefreshPigRunsList');
        this.endPigRunConfirmDialog = false;
        this.endPigRunDialog = false;
      } catch (err) {
        console.error('endPigRun failed:', err);
      }
    },
    async onSaveLaunchTime() {
      if (!this.pigRun) return;

      const ts = this.LaunchTimestamp;
      if (!ts) return;

      const launchDate = new Date(ts.replace(' ', 'T') + 'Z');
      if (isNaN(launchDate.getTime())) return;

      // Launch time cannot be in the future
      if (launchDate.getTime() > Date.now()) {
        this.ErrorMsg = true;
        return;
      }

      try {
        const isoDate = ts.replace(' ', 'T');
        const response = await PigRunService.updateLaunchDate(
          this.pigRun.pigRunId,
          isoDate
        );
        this.$store.commit('SET_PIG_RUN', response.data);
        this.Launch_at_TimeDialog = false;
        this.ErrorMsg = false;
      } catch (err) {
        console.error('updateLaunchDate failed:', err);
      }
    },
    onCancelEditSpeed() {},
    onEditRunSpeed() {},
    onCloseNewMarkerSetup() {
      const map: L.Map | undefined = this.$store.state.map;
      if (this.tempAGMMarker && map) {
        this.tempAGMMarker.removeFrom(map);
        this.tempAGMMarker = null;
      }
    },
    async onSaveNewMarker() {
      // Remove the temp marker from the map
      const map: L.Map | undefined = this.$store.state.map;
      if (this.tempAGMMarker && map) {
        this.tempAGMMarker.removeFrom(map);
        this.tempAGMMarker = null;
      }

      // Validate marker name
      this.newMarkerError = '';
      const name = this.newMarkerName.trim();

      if (!name) {
        this.newMarkerError = 'Marker name is required.';
        return;
      }

      if (name.length > 20) {
        this.newMarkerError = 'Marker Name is limited to 20 characters.';
        return;
      }

      if (this.pigRun?.markers) {
        const duplicate = this.pigRun.markers.some(
          (m: PipelineSectionMarker) =>
            m.name.toLowerCase() === name.toLowerCase()
        );
        if (duplicate) {
          this.newMarkerError =
            'A marker with this name already exists. Please enter a unique name.';
          return;
        }
      }

      try {
        if (this.selectedDeviceUid == null) {
          this.newMarkerError = 'A device is required.';
          return;
        }

        const response = await PigRunService.addDynamicMarker({
          pigRunId: this.pigRun.pigRunId,
          name,
          latitude: parseFloat(this.newMarker_lat),
          longitude: parseFloat(this.newMarker_lon),
          deviceUid: this.selectedDeviceUid,
        });

        this.$store.commit('SET_PIG_RUN', response.data);
        this.addMarkerDialog = false;
        this.newMarkerName = '';
        this.newMarkerError = '';
        this.selectedDeviceUid = null;
      } catch (err) {
        console.error('addDynamicMarker failed:', err);
        this.newMarkerError = 'Failed to save marker. Please try again.';
      }
    },
    onCancelWaveformSelection() {},
    onConfirmWaveformSelection() {},
    pigRunNotificationsToUserNotifications(
      notifications: PigRunNotification[]
    ): UserNotification[] {
      const userMap = new Map<
        string,
        {
          userName: string;
          launch: boolean;
          receive: boolean;
          channels: Set<string>;
          passageType: string;
          manualPassage: boolean;
          markerIds: Set<number>;
          hasNullMarker: boolean;
        }
      >();

      for (const n of notifications) {
        if (!userMap.has(n.userId)) {
          userMap.set(n.userId, {
            userName: n.userName || n.userId,
            launch: false,
            receive: false,
            channels: new Set(),
            passageType: 'verified',
            manualPassage: false,
            markerIds: new Set(),
            hasNullMarker: false,
          });
        }
        const entry = userMap.get(n.userId)!;
        entry.channels.add(n.notificationChannel);

        switch (n.notificationEventType) {
          case 'PIG_RUN_LAUNCH_EVENT':
            entry.launch = true;
            break;
          case 'PIG_RUN_RECEIVE_EVENT':
            entry.receive = true;
            break;
          case 'VERIFIED_PASSAGE_EVENT':
            entry.passageType = 'verified';
            break;
          case 'AUTOMATED_PASSAGE_EVENT':
            entry.passageType = 'passage';
            break;
          case 'MANUAL_PASSAGE_EVENT':
            entry.manualPassage = true;
            break;
        }

        if (n.markerIdentityId == null) {
          entry.hasNullMarker = true;
        } else {
          entry.markerIds.add(n.markerIdentityId);
        }
      }

      // Resolve channel: SMS+EMAIL=both, else whichever is present
      const result: UserNotification[] = [];
      for (const [userId, entry] of userMap) {
        let medium = 'sms';
        if (entry.channels.has('SMS') && entry.channels.has('EMAIL')) {
          medium = 'both';
        } else if (entry.channels.has('EMAIL')) {
          medium = 'email';
        } else if (entry.channels.has('SMS')) {
          medium = 'sms';
        }

        const allMarkers = entry.hasNullMarker || entry.markerIds.size === 0;
        let markerNames: string[] | undefined;
        if (!allMarkers && this.pigRun.markers) {
          markerNames = this.pigRun.markers
            .filter((m) => entry.markerIds.has(m.markerIdentityId))
            .map((m) => m.name);
        }
        result.push(
          new UserNotification(
            entry.userName,
            userId,
            entry.launch,
            entry.receive,
            medium,
            entry.passageType,
            entry.manualPassage,
            allMarkers,
            markerNames
          )
        );
      }
      return result;
    },
    userNotificationsToPigRunNotifications(
      notifications: UserNotification[]
    ): PigRunNotification[] {
      const result: PigRunNotification[] = [];

      for (const n of notifications) {
        const eventTypes: string[] = [];
        if (n.launch) eventTypes.push('PIG_RUN_LAUNCH_EVENT');
        if (n.receive) eventTypes.push('PIG_RUN_RECEIVE_EVENT');
        if (n.passageType === 'verified') {
          eventTypes.push('VERIFIED_PASSAGE_EVENT');
        } else {
          eventTypes.push('AUTOMATED_PASSAGE_EVENT');
        }
        if (n.manualPassage) eventTypes.push('MANUAL_PASSAGE_EVENT');

        // Expand medium into channels
        const channels: string[] = [];
        if (n.medium === 'sms' || n.medium === 'both') channels.push('SMS');
        if (n.medium === 'email' || n.medium === 'both') channels.push('EMAIL');
        if (channels.length === 0) channels.push('SMS');

        const markerIds: (number | null)[] = [];
        if (n.allMarkers || !n.markers || n.markers.length === 0) {
          markerIds.push(null);
        } else if (this.pigRun.markers) {
          for (const name of n.markers) {
            const marker = this.pigRun.markers.find((m) => m.name === name);
            if (marker) markerIds.push(marker.markerIdentityId);
          }
        }

        for (const eventType of eventTypes) {
          for (const channel of channels) {
            for (const markerId of markerIds) {
              result.push({
                userId: n.userId,
                notificationEventType: eventType,
                notificationChannel: channel,
                markerIdentityId: markerId,
              });
            }
          }
        }
      }
      return result;
    },
    hideDateProxy() {
      hidePopupProxy(this, 'qDateProxy');
    },
    hideTimeProxy() {
      hidePopupProxy(this, 'qTimeProxy');
    },
  },
});
</script>

<style scoped>
.status-width {
  height: 5px;
}

/* Add Marker instruction card */
</style>
